import { fetchAuthSession, signIn } from '@aws-amplify/auth';
import { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { AuthGate, LocalStorageKeys } from '@/modules/common';
import { Routes } from '@/router/routes';

import { SignInForm } from '../components';

export const SignInPage: FC = () => {
  const navigate = useNavigate();
  const [isLoggingIn, setIsLoggingIn] = useState(false);

  const signInUser = async ({ email, password }) => {
    try {
      setIsLoggingIn(true);
      await signIn({
        password,
        username: email,
      });
      const response = await fetchAuthSession();
      localStorage.setItem(
        LocalStorageKeys.AccessToken,
        response.tokens.accessToken.toString()
      );
      navigate(Routes.Models, { replace: true });

      return { error: null };
    } catch (error) {
      return { error: error.message };
    } finally {
      setIsLoggingIn(false);
    }
  };

  return (
    <AuthGate>
      <div className="flex h-screen flex-col justify-center items-center px-6 py-12 lg:px-8">
        <div className="mx-auto gap-y-2 flex flex-col items-center">
          <h1 className="scroll-m-20 text-4xl font-extrabold tracking-tight lg:text-5xl">
            Welcome
          </h1>

          <p className="text-zink-400">
            Log in to account with your Email and Password
          </p>
        </div>

        <div className="mt-10 px-6 sm:mx-auto sm:w-full sm:max-w-sm">
          <SignInForm onSubmit={signInUser} isLoading={isLoggingIn} />
        </div>
      </div>
    </AuthGate>
  );
};
